$(document).ready(function () {
    function homeOnePage() {
        const vw = $(window).innerWidth();

        if (vw > 1366) {
            $('html.home').addClass('onePage');
        }
        else {
            $('html.home').removeClass('onePage');
        }
    }

    homeOnePage();

    $(window).resize(homeOnePage);

    $(window).scroll(function () {
        homeOnePage();
        $(window).resize(homeOnePage);
    });

    $('.onePage main').onepage_scroll({
        sectionContainer: 'section',
        loop: false,
        pagination: false,
        responsiveFallback: 1367,
    });

    $('.home .onePage-next').click(function (e) {
        $('.onePage main').moveDown();
    });
});
